import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/home/home.vue'),
    },
    {
      path: '/need-help',
      name: 'help',
      component: () => import('./components/help/need-help.vue'),
    },
    {
      path: '/selfcare-raise-complaint',
      name: 'SelfcareRaiseComplaint',
      component: () =>
        import(
          './components/selfcare-raise-complaint/main-category/raise-complaint.vue'
        ),
      props: true,
    },
    {
      path: '/level-one/product-related',
      name: 'ProductListing',
      component: () =>
        import(
          './components/selfcare-raise-complaint/products-listing/product-listing.vue'
        ),
      props: true,
    },
    {
      path: '/level-two/:url',
      name: 'SubCategory',
      component: () =>
        import(
          './components/selfcare-raise-complaint/sub-category-level2/sub-category.vue'
        ),
      props: true,
    },
    {
      path: '/level-three/:url',
      name: 'LevelThreeCategory',
      component: () =>
        import(
          './components/selfcare-raise-complaint/subsub-category-level3/category-level-three.vue'
        ),
      props: true,
    },
    {
      path: '/level-four/:url',
      name: 'SubSubCategory',
      component: () =>
        import(
          './components/selfcare-raise-complaint/subsub-category-level4/subsub-category.vue'
        ),
      props: true,
    },
    {
      path: '/view-status',
      name: 'ViewStatus',
      component: () =>
        import(
          './components/selfcare-raise-complaint/view-status/view-status.vue'
        ),
      props: true,
    },
    {
      path: '/verify-token',
      name: 'VerifyToken',
      component: () =>
        import(
          './components/selfcare-raise-complaint/verify-token/verify-token.vue'
        ),
      props: true,
    },
    {
      path: '/knowledge-center',
      name: 'knowledgeCenter',
      component: () =>
        import(
          './components/selfcare-raise-complaint/knowledge-center/knowledge-center.vue'
        ),
      props: true,
    },
    {
      path: '/view-history',
      name: 'ViewHistory',
      component: () =>
        import(
          './components/selfcare-raise-complaint/view-history/view-history.vue'
        ),
      props: true,
    },
    {
      path: '/help-raise-complaint',
      name: 'HelpRaiseComplaint',
      component: () =>
        import(
          './components/selfcare-raise-complaint/help-raise-complaint/help-raise-complaint.vue'
        ),
      props: true,
    },
    {
      path: '/session-validation',
      name: 'SessionValidation',
      component: () =>
        import('./components/session-validation/session-validation.vue'),
      props: true,
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: () => import('./components/not-found/not-found.vue'),
      props: true,
    },
    {
      path: '/transaction-history',
      name: 'TransactionHistory',
      component: () =>
        import('./components/transaction-history/transaction-history.vue'),
      props: true,
    },
    {
      path: '/help-topics/:url',
      name: 'HelpTopics',
      component: () =>
        import(
          './components/selfcare-raise-complaint/help-topics/help-topics.vue'
        ),
      props: true,
    },
    {
      path: '/main-category',
      name: 'CategoryList',
      component: () =>
        import(
          './components/selfcare-raise-complaint/main-category-list/main-category-list.vue'
        ),
      props: true,
    },
    {
      path: '/history-raise-complaint',
      name: 'HistoryRaiseComplaint',
      component: () =>
        import(
          './components/history-raise-complaint/history-raise-complaint.vue'
        ),
      props: true,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// router.beforeEach((to,from,next) => {
//   if(to.name === 'SelfcareRaiseComplaint'){
//     console.log(router);
//   }
//   next();
// });
const patchRouterMethod = (router, methodName) => {
  router['old' + methodName] = router[methodName]
  router[methodName] = async function (location) {
    return router['old' + methodName](location).catch((error) => {
      if (error.name === 'NavigationDuplicated') {
        return this.currentRoute
      }
      throw error
    })
  }
}

patchRouterMethod(router, 'push')
patchRouterMethod(router, 'replace')

export default router;
